import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizeGuard } from 'src/app/core/guards/authorize.guard';
import { InvoiceDetailComponent } from './invoice-detail/invoice-detail.component';
import { InvoiceListComponent } from './invoices-list/invoice-list.component';
import { RightsGuard } from 'src/app/core/guards/rights.guard';

const routes: Routes = [
  {
    path: 'invoices',
    canActivate: [AuthorizeGuard, RightsGuard],
    children: [
      { path: '', component: InvoiceListComponent },
      { path: ':invoiceId', component: InvoiceDetailComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class InvoicesRoutingModule {}
